'use client'

// RadioTower — a decimated radio mast baked to a single 512 map in Blender,
// with the town placement baked into the export (drops in at identity like
// Buildings/Ruins). KTX2 texture + Draco geometry (UVs aren't critical on this
// one, so Draco's fine). Material rebuilt as a MeshStandardNodeMaterial so it
// lights, shadows, and runs through RendererDither with the world.

import { useEffect } from 'react'
import * as THREE from 'three/webgpu'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/radio_tower.glb'

export function RadioTower() {
  const { scene } = useModel(MODEL)

  useEffect(() => {
    // Convert each glTF material to a fresh MeshStandardNodeMaterial (the
    // useNodeMaterials pattern — set maps/params EXPLICITLY, never copy()).
    const converted = new Map()
    scene.traverse((o) => {
      if (!o.isMesh) return
      o.castShadow = true
      o.receiveShadow = true
      const src = o.material
      if (!src || Array.isArray(src) || src.isNodeMaterial) return
      let nm = converted.get(src)
      if (!nm) {
        nm = new THREE.MeshStandardNodeMaterial()
        if (src.map) nm.map = src.map
        nm.color = src.color?.clone() ?? new THREE.Color('white')
        nm.roughness = src.roughness ?? 1
        nm.metalness = src.metalness ?? 0
        nm.side = src.side
        nm.vertexColors = src.vertexColors
        converted.set(src, nm)
      }
      o.material = nm
    })
  }, [scene])

  // Placement baked into the export — render at identity.
  return <primitive object={scene} />
}

export default RadioTower
